module.exports = {
      id: "v-plus-logo-usage",
      viewBox: "0 0 165.404 72.698",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#v-plus-logo",
      toString: function () {
        return this.url;
      }
    }